const e = {
  name: "Wall",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h40v38H0V0z M38,2h-8v10h8V2z M28,2H12v10h16V2z M2,12h8V2H2V12z M21,14v10h17V14H21z M19,14H2v10h17V14z
			 M38,26h-8v10h8V26z M12,26v10h16V26H12z M10,26H2v10h8V26z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Wall
};
